/**
 * Purpose: Provides collapsible UI component for expandable/collapsible sections
 *
 * How it works:
 * 1. Uses Radix UI's Collapsible primitive for accessibility
 * 2. Provides controlled or uncontrolled state management
 * 3. Handles animations with CSS transitions
 *
 * Key features:
 * - Accessible expand/collapse functionality
 * - Smooth animations
 * - Customizable styling
 * - Keyboard navigation support
 */

"use client";

import * as React from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.Trigger;

const CollapsibleContent = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <CollapsiblePrimitive.Content ref={ref} className={className} {...props}>
    {children}
  </CollapsiblePrimitive.Content>
));

CollapsibleContent.displayName = "CollapsibleContent";

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
